import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ChatSmartComponent } from './chat-smart/chat-smart.component';
import { TranscriptModule } from 'app/transcript/transcript.module';

@NgModule({
    declarations: [ChatSmartComponent],
    imports: [
        CommonModule,
        TranscriptModule,
    ],
    exports: [
        ChatSmartComponent
      ]
})
export class ChatModule { }
